"use strict";

/**
* Adjusts the position of the eye icon button in the password field based on the height of any error message present.
* This function targets elements with the class 'invalid-feedback' within the '.password-form-wrapper' and adjusts
* the bottom position of the associated '.button__eye' icon to ensure it is properly aligned with the input field.
* 
* The adjustment is calculated by adding a fixed distance to the height of the error message.
* 
* @function
* @returns {void} This function does not return a value.
*/
const setEyeButtonPosition = () => {
    // adjust Eye icon position in the password field depending on the error element height (if any error is present)
    let passwordInvalidErrors = document.querySelectorAll(".password-form-wrapper .invalid-feedback");

    if (passwordInvalidErrors) {
        Array.from(passwordInvalidErrors).forEach(invalidError => {
            const eyeIconButton = invalidError.parentNode.querySelector(".button__eye");
            const errorHeight = invalidError.offsetHeight;
            const elementBottomDistance = 12;

            eyeIconButton.style.bottom = elementBottomDistance + errorHeight + "px";
        });
    }
};

module.exports = setEyeButtonPosition;
